// Only the subscriptions destination is preserved. No arbitrary redirect input.
export function signInDestination(
  path: string,
  search: string,
  savedInterval: string | null,
  enterprise = false
): string {
  if (enterprise) return "/account";
  const interval =
    new URLSearchParams(search).get("billing_interval") || savedInterval;
  if (interval === "year") return "/subscriptions?billing_interval=year";
  return path === "/subscriptions" ? "/subscriptions" : "/account";
}
